import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }

    :host(:not(:last-child)) {
        margin-bottom: 2px;
    }

    .sidebar-item {
        ${theme.cssBorderRadius('L')};
        ${theme.colors.cssColor('gray-700')};
        ${theme.texts.cssBody('normal', 'M')};
        ${theme.spacings.cssPaddingY('XS')};
        ${theme.spacings.cssPaddingX('S')};
        cursor: pointer;
        transition:
            background-color 0.12s ease,
            color 0.12s ease;
    }

    .sidebar-item:hover {
        ${theme.colors.cssBackground('neutral', 'hover')};
    }

    .sidebar-item--active,
    .sidebar-item--active:hover {
        ${theme.colors.cssBackground('secondary')};
        ${theme.colors.cssColor('primary-700')};
        font-weight: var(--sgdf-font-weight-semibold);
    }
`;
//# sourceMappingURL=sidebar-item.styles.js.map